import React, { useContext, useState } from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { H1, H3 } from '../../text';
import CdnImageBackground from '../../common/CdnImageBackground';
import LayoutContext from '../../../contexts/Layout';

export const Header = ({ eventTitle, eventTitleColor, featuredImage, renderButtons, sameDay, hardWidth, width }) => {
    const { layout } = useContext(LayoutContext);
    const [imageDimensions, setImageDimensions] = useState();

    return (
        <View>
            <CdnImageBackground
                imageDimensions={imageDimensions}
                setImageDimensions={setImageDimensions}
                uri={featuredImage.cdnImagePath}
                width={hardWidth}
                style={{ width }}
                dataSet={{ spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
            >
                {layout.device.isDesktopOrLaptop && !!eventTitle && (
                    <H1
                        style={{ bottom: 10, color: eventTitleColor, marginLeft: layout.styleGuide.spacer2, position: 'absolute' }}
                        text={eventTitle}
                        dataSet={{ spacerLeft: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
                    />
                )}
            </CdnImageBackground>
            <View
                style={{ backgroundColor: '#f8f9fa' }}
                dataSet={{ spacerLeft: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`, spacerRight: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
            >
                <View style={{ marginHorizontal: layout.styleGuide.spacer2, marginVertical: layout.styleGuide.spacer2 }}>
                    {!layout.device.isDesktopOrLaptop && <H3 text={eventTitle} />}
                    <View style={{ flexDirection: 'row' }}>
                        <H3 text={sameDay} />
                    </View>
                    {renderButtons(false)}
                </View>
            </View>
        </View>
    );
};

Header.propTypes = {
    addToCalendarButton: PropTypes.node,
    ctaButton: PropTypes.node,
    id: PropTypes.string,
    eventTitle: PropTypes.string.isRequired,
    eventTitleColor: PropTypes.string,
    renderButtons: PropTypes.func.isRequired,
    sameDayTest: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
